import React from "react";

function Footer() {
  return React.createElement(
    "footer",
    { className: "site-footer" },
    `\u00A9 ${new Date().getFullYear()} Van Carlo Labanan. All rights reserved.`,
    React.createElement(
      "a",
      {
        href: "#cover",
        className: "footer-top-link",
        onClick: function (e) {
          e.preventDefault();
          const section = document.getElementById("cover");
          if (section) section.scrollIntoView({ behavior: "smooth" });
        },
      },
      "\u2191 back to top",
    ),
  );
}

export default Footer;
